export default __webpack_public_path__ + "static/media/010_photo.806d213f.jpg";